import { useCallback, useEffect, useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import { KTSVG } from 'src/_metronic/helpers';

interface IProps {
  chooseOneDefinedError?: (Error | string | undefined)[];
  show: boolean | boolean[];
  onClose?: () => void;
  useDefaultMessageIfErrorNotFound?: boolean;
}

const initialMessage = 'Bir şeyler ters gitti... Lütfen daha sonra tekrar deneyin.';

const FetchErrorModal = (props: IProps) => {
  const { chooseOneDefinedError, show: showInProps, useDefaultMessageIfErrorNotFound = true, onClose } = props;
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
    onClose?.();
  }, [onClose]);

  const errorMessage = useMemo(() => {
    let errorArray = chooseOneDefinedError;
    if (chooseOneDefinedError && !Array.isArray(chooseOneDefinedError)) errorArray = [chooseOneDefinedError];

    const foundError: any = errorArray?.find((error) => !!error);

    if (foundError) {
      if (typeof foundError === 'string') {
        return foundError;
      }
      return foundError?.response?.data?.message;
    }

    if (useDefaultMessageIfErrorNotFound) return initialMessage;
    return '';
  }, [chooseOneDefinedError, useDefaultMessageIfErrorNotFound]);

  useEffect(() => {
    if (typeof showInProps === 'boolean') {
      setShowModal(showInProps);
    } else {
      setShowModal(showInProps.some((show) => show));
    }
  }, [showInProps]);

  return (
    <Modal className={`modal fade h-100 `} size={'sm'} show={showModal} onHide={handleCloseModal} centered>
      <div className="modal-content">
        <div className="modal-body text-center d-flex flex-column align-items-center ">
          <KTSVG path="/media/icons/duotone/Alerts/alert-circle.svg" className="svg-icon-5x text-danger mb-5" />
          <div className="w-100 text-wrap text-break">{errorMessage || initialMessage}</div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary w-100" onClick={handleCloseModal}>
            Kapat
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default FetchErrorModal;
